import { render } from "./HeaderChallengeList.vue?vue&type=template&id=6ffb4ef1&scoped=true"
import script from "./HeaderChallengeList.vue?vue&type=script&lang=js"
export * from "./HeaderChallengeList.vue?vue&type=script&lang=js"

import "@/css/components/header-challenge-list.css?vue&type=style&index=0&id=6ffb4ef1&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffb4ef1"]])

export default __exports__